import React from 'react';
import './Gallery.css';

import { PageTitle } from '../../../components';
import { gallery } from '../../../constants';

import { FaPlus } from 'react-icons/fa';

import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';



const Gallery = () => {

  return (
    <>

      {/* Page Title */}
      <PageTitle title={'Gallery'} page={'Gallery'} />

      <section className='gallery'>

        {/* Image Grid Container */}
        <div className='box-container'>
          {/* PhotoProvider to handle image preview */}
          <PhotoProvider>
            {gallery.map((item) => (

              <div className='gallery-item' key={item.id}>

                {/* Display Image */}
                <img src={item.image} alt={`gallery-${item.id + 1}`} /> 

                {/* Image Hover Effect with Icon */}
                <div className='content'>
                  <h4>{item.title}</h4>
                  <PhotoView key={item.id} src={item.image}>
                    <div className='icon'><FaPlus /></div>
                  </PhotoView>
                </div>

              </div>
    
            ))}
          </PhotoProvider>
        </div>
      </section>

    </>



  );
};

export default Gallery;